import nxModule from 'nxModule';

const templateUrl = require('./gl-accounts.template.html');
nxModule.component('glAccounts', {
  templateUrl,
});
